import React, { Component } from 'react';
import Layout from '../../ui/Layout';
// import { Link } from 'react-router-dom';
import ShopBy from './ShopGrid/ShopBy';

class ProductNotFound extends Component {
  componentDidMount() {
    document.body.classList.add('error404', 'hfeed', 'no-sidebar');
  }
  componentWillUnmount() {
    document.body.classList.remove('error404', 'hfeed', 'no-sidebar');
  }
  render() {
    const scrollToTop = () => window.scrollTo(0, 0);

    return (
      <Layout>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main shop-page nohero">
              <div className="container">
                <div className="row">
                  <div className="col-filters">
                    <ShopBy />
                  </div>
                  <div className="col-products">
                    <div className="row">
                      <div className="col-12">
                        <h1 className="h3-style column-header-alt grid-header">
                          Sorry the product you were searching for is no longer available.
                        </h1>
                      </div>
                    </div>
                    <div style={{ marginTop: '20px' }}>
                      <p className="bigger">
                        Please browse our shop for more Twomey products.
                      </p>
                      {/* <p><Link to="/shop/">Shop</Link></p> */}
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
          <div className="container text-right">
            <a href="#top" className="back-to-top" onClick={scrollToTop}>
              Back to top
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

export default ProductNotFound;
